// lib/api/client.ts
// ─────────────────────────────────────────────────────────────────────────────
// Unified API Client Bridge
// ─────────────────────────────────────────────────────────────────────────────
// This module re-exports the enterprise-grade API client from ./apiClient.
// All imports of '@/lib/api/client' automatically receive:
//   ✅ Rate-limiting (5 req/min per endpoint)
//   ✅ Request queue with sequential processing
//   ✅ Automatic 401 → silent token refresh via HttpOnly cookie
//   ✅ X-Request-ID tracing headers for observability
//   ✅ PCI-DSS compliant payload redaction (passwords, tokens)
//   ✅ withCredentials: true for HttpOnly cookie transport
// ─────────────────────────────────────────────────────────────────────────────

export { apiClient, api, baseURL } from './apiClient';
export { apiClient as default } from './apiClient';
